const roundNumber = (num, scale) => {
	if ((`${num}`).indexOf('e') < 0) {
		return +(`${Math.round(`${num}e+${scale}`)}e-${scale}`);
	}
	const arr = (`${num}`).split('e');
	let sig = '';
	if (+arr[1] + scale > 0) {
		sig = '+';
	}
	return +(`${Math.round(`${+arr[0]}e${sig}${+arr[1] + scale}`)}e-${scale}`);
};

const convertNumber = (number, exchangeCoefficient = 1, rounding = 3) => {
	if (number % 1 !== 0) return number;
	if (exchangeCoefficient === 1) {
		const x = roundNumber(number, rounding).toString();
		let lastThree = x.substring(x.length - 3);
		const otherNumbers = x.substring(0, x.length - 3);
		if (otherNumbers !== '') { lastThree = `,${lastThree}`; }
		const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
		return (res);
	}
	// Round to second decimal place
	return (roundNumber(number, rounding).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
};

export default convertNumber;
